import { IMediaFile } from "@/service/service";
import { DataRecord, Editor } from "grapesjs";

const SoMeImageSize = {
  width: 1200,
  height: 630,
  ratio: true,
};

export const SoMeImageSizeQuery = `?width=${SoMeImageSize.width}&height=${
  SoMeImageSize.height
}&ratio=${SoMeImageSize.ratio.valueOf()}`;

export interface OpenGrapProtocolMeta {
  description: string;
  image: string;
  title: string;
  type?: string;
  url: string;
}

export const OpenGraphHeadHTML = ({
  title,
  description,
  url,
  image,
  type,
}: OpenGrapProtocolMeta) => `
      <title>${title}</title>
      <meta name="description" content="${description}">
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <meta charset="UTF-8">
  
      <meta property="og:title" content="${title}" />
      <meta property="og:description" content="${description}" />
      <meta property="og:url" content="${url}" />
      <meta property="og:image" content="${image}${SoMeImageSizeQuery}" />
      <meta property="og:type" content="${type || "website"}" />
  
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="${title}" />
      <meta name="twitter:description" content="${description}" />
      <meta name="twitter:image" content="${image}${SoMeImageSizeQuery}" />
      <meta name="twitter:url" content="${url}" />
      `;

export const getOpenGraphValues = (editor: Editor) => {
  return editor.DataSources.get("openGraph")?.records.find(
    (record: DataRecord<OpenGrapProtocolMeta & { id: string }>) =>
      record.id === "meta"
  ).attributes as OpenGrapProtocolMeta;
};

export const getFaviconValues = (editor: Editor) => {
  return editor.DataSources.get("favicon")?.records.find(
    (record: DataRecord<{ id: string; link: string }>) =>
      record.id === "meta"
  ).attributes as IMediaFile;
};
